import { trpc } from "../../../../common/helpers/trpc";
import { keepPreviousData } from "@tanstack/react-query";

interface UseCustomAssetLibraryImagesProps {
  enabled: boolean;
  limit?: number;
}

// Long enough for ImageUploader optimistic inserts to outlast Cloudinary Search index lag.
const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const useCustomAssetLibraryImages = ({ enabled, limit = 50 }: UseCustomAssetLibraryImagesProps) => {
  const { data, isLoading } = trpc.listCustomAssetLibraryImages.useQuery(
    { limit },
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - tRPC types don't properly support enabled option, but it works at runtime
      enabled: Boolean(enabled),
      placeholderData: keepPreviousData,
      staleTime: FIVE_MINUTES_MS,
    }
  );

  return {
    images: enabled ? (data ?? []) : [],
    isLoading: enabled && isLoading,
  };
};
